/** The preferences for a service */
import type { PickUnion } from '../../../types/PickUnion'
import type { FilterGroupObject } from './FilterDefinition'
import type { FilterIds } from '../../../types/FilterIds'

export type ServiceFilterPreferences = PickUnion<
  FilterIds,
  | 'preferences:peer-support'
  | 'preferences:for-students'
  | 'preferences:for-carers-and-families'
  | 'preferences:prison-and-probation-friendly'
  | 'preferences:epilepsy-friendly'
  | 'preferences:for-men'
  | 'preferences:for-women'
>

export const serviceFilterPreferences = [
  'preferences:peer-support',
  'preferences:for-students',
  'preferences:for-carers-and-families',
  'preferences:prison-and-probation-friendly',
  'preferences:epilepsy-friendly',
  'preferences:for-men',
  'preferences:for-women'
] as const

type PreferencesType = FilterGroupObject<ServiceFilterPreferences>

export const generateServiceFilterPreferencesObjects = (): PreferencesType => ({
  'preferences:peer-support': {
    selected: false,
    label: 'Peer Support',
    key: 'preferences:peer-support',
    filterId: 'preferences:peer-support',
    toolTipContent: `Peer support brings people of a similar age or with similar characteristics or experiences together to help each other and feel understood. It's usually led by someone who has been trained in mental health support.`,
    serviceFilterKey: 'offersPeerGroupSupport'
  },
  'preferences:for-students': {
    selected: false,
    label: 'For Students',
    key: 'preferences:for-students',
    filterId: 'preferences:for-students',
    serviceFilterKey: 'forStudents'
  },
  'preferences:for-women': {
    selected: false,
    label: 'For Women',
    key: 'preferences:for-women',
    filterId: 'preferences:for-women',
    serviceFilterKey: 'offersWomensSupport'
  },
  'preferences:for-men': {
    selected: false,
    label: 'For Men',
    key: 'preferences:for-men',
    filterId: 'preferences:for-men',
    serviceFilterKey: 'offersMensSupport'
  },
  'preferences:for-carers-and-families': {
    selected: false,
    label: 'For Carers and Families',
    key: 'preferences:for-carers-and-families',
    filterId: 'preferences:for-carers-and-families',
    serviceFilterKey: 'forCarersAndFamilies'
  },
  'preferences:prison-and-probation-friendly': {
    selected: false,
    label: 'Prison and Probation Friendly',
    key: 'preferences:prison-and-probation-friendly',
    filterId: 'preferences:prison-and-probation-friendly',
    serviceFilterKey: 'isPrisonAndProbationFriendly',
    toolTipContent:
      'Services or activities designed to support people with experience of prison or probation and their families. These services help improve the mental health of both individuals and their loved ones, who may face stress and stigma.'
  },
  'preferences:epilepsy-friendly': {
    selected: false,
    label: 'Epilepsy Friendly',
    key: 'preferences:epilepsy-friendly',
    filterId: 'preferences:epilepsy-friendly',
    serviceFilterKey: 'isEpilepsyFriendly'
  }
})
